$(document).ready(function() {
    if ($('body').data('router-name') !== 'rule-edit') {
        return;
    }

    $(function() {
        var $form = $('[data-rule-type]');
        if ($form.length === 0) {
            return false;
        }

        var hideElements = function(ruleType) {
            var $selectNotEmptyTextTarget = $('[name="not_empty_text_target[]"]');

            if (ruleType === 'translate-sync') {
                $selectNotEmptyTextTarget.closest('.form-row').show();
            } else {
                $selectNotEmptyTextTarget.closest('.form-row').hide();
                $selectNotEmptyTextTarget.val('').chosen().trigger('chosen:updated');
            }
        };


        var ruleType = $form.find('[name="type"]').length ? $form.find('[name="type"]').val() : $form.data('rule-type');
        hideElements(ruleType);

        $form.find('[name="type"]').on('change', function() {
            hideElements($(this).val());
        });
    });
});
